export * from './lib/metal-detection';
